import Modal from 'shared/components/Modal'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const ContainerIcon = styled.div`
  display: flex;
  width: 100px;
  height: 100px;
  border: 2px solid ${colors.redLight};
  background-color: ${colors.redLight};
  border-radius: 50%;
  align-items: center;
  justify-content: center;

  svg {
    width: 45px;
    height: 45px;
  }

  svg > path {
    stroke: ${colors.white};
  }
`

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;

  padding-top: 16px;

  & > div:last-child {
    padding: 8px 0px;
  }
`

export const ContainerButton = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

interface IModalProps {
  img: string
}

export const StyledModal = styled(Modal)<IModalProps>`
  & > div {
    background-image: url(${props => props.img});
    background-repeat: no-repeat;
  }
`
